import { Controller } from "@hotwired/stimulus"

import { queryClient } from "@hootie/queryClient"
import { VueQueryPlugin } from "@tanstack/vue-query"
import { createApp, type App as VueApp } from "vue"

export default class extends Controller<HTMLElement> {
  private app?: VueApp
  static values = { requisitionUuid: String, token: String }

  declare requisitionUuidValue: string
  declare tokenValue: string

  async connect(): Promise<void> {
    const { default: App } = await import("@/v2/hootie/App.vue")
    if (!this.element.isConnected) return

    this.app = createApp(App, {
      requisitionUuid: this.requisitionUuidValue,
      token: this.tokenValue,
    })
    this.app.use(VueQueryPlugin, { queryClient })
    this.app.mount(this.element)
  }

  disconnect(): void {
    this.app?.unmount()
  }
}
